/* jQuery Tiny Pub/Sub - v0.7 - 10/27/2011
 * http://benalman.com/
 * Copyright (c) 2011 "Cowboy" Ben Alman; Licensed MIT, GPL */

(function ($) {
  const o = $({})

  $.subscribe = function () {
    o.on.apply(o, arguments)
  }

  $.unsubscribe = function () {
    o.off.apply(o, arguments)
  }

  $.publish = function () {
    o.trigger.apply(o, arguments)
  }
}(jQuery));

(function ($) {
  /* Testing if certain attributes are supported */
  $.fn.attributeSupported = function (elem, attr) {
    const test = document.createElement(elem)
    return (attr in test)
  }
  /* Testing if certain input type are supported */
  $.fn.inputTypeSupported = function (type) {
    const input = document.createElement('input')
    input.setAttribute('type', type)

    return (input.type === type)
  }

  /* Test if  transitions is supported, with or without vendor-prefix */
  $.fn.transitionSupported = function () {
    const b = document.body || document.documentElement
    const s = b.style
    let p = 'transition'
    let v = ''
    if (typeof s[p] == 'string') {
      return true
    }

    // Tests for vendor specific prop
    v = ['Moz', 'Webkit', 'Khtml', 'O', 'ms'],
    p = p.charAt(0).toUpperCase() + p.substr(1)
    for (let i = 0; i < v.length; i++) {
      if (typeof s[v[i] + p] == 'string') {
        return true
      }
    }
    return false
  }

  /*
    Test for CSS-support
    Props to http://jsfiddle.net/Skateside/5dKc7/5/
    */
  $.fn.cssSupport = function (selector) {
    const doc = document
    let el = doc.createElement('style')
    let supported = false
    let theRules

    // IE seems to need a type to recognise a stylesheet.
    el.type = 'text\/css'

    // This ASSUMES that IE will always give stylesheets a styleSheet method.
    // Watch this space for errors.
    if (el.styleSheet) {
      el.styleSheet.cssText = `${selector}{}`
      // May as well save some typing.
      if (el.styleSheet.cssRules) {
        theRules = el.styleSheet.cssRules
      } else {
        // Need to try/catch here since IE6 + 7 throws an error
        try {
          theRules = el.styleSheet.rules
        } catch (e) {
          // Since I can't check rules I will say unsupported since that safest
          // Don't do anything unsafe like apply crazy conflicting styling when not supported!
          return supported
        }
      }

      // IE7 and 8 map '::before' to ':before' so we can't simply
      // check that our selector is the same as the returned one.
      // The selectorText of any unrecognised selector is 'UNKNOWN' and
      // unrecognised Pseudo-elements come back as ':unknown', so we can
      // check for that.
      if (theRules) {
        supported = (theRules && theRules[0] && theRules[0].selectorText && theRules[0].selectorText.toLowerCase().indexOf('unknown') < 0)
      }
    } else {
      // Standards-based browsers need the stylesheet to be appended to the
      // DOM, but they will allow us to simply give the style tag some text.
      el.appendChild(doc.createTextNode(`${selector}{}`))
      doc.body.appendChild(el)
      supported = !!el.sheet.cssRules.length
      doc.body.removeChild(el)
    }

    // Clean up after ourselves and give us the results.
    el = null
    return supported
  }
}(jQuery))
